import {
  Box,
  Button,
  Center,
  Flex,
  Grid,
  GridItem,
  HStack,
  Image,
  Input,
  InputGroup,
  InputRightElement,
  Text,
} from "@chakra-ui/react";
import { ChangeEvent, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AdminDashboardHeader from "../../../components/admin/AdminHeader";
import AdminSidebar from "../../../components/admin/AdminSidebar";
import Adminroutes from "../routes";

import { RiSearch2Line } from "react-icons/ri";
import surveytemplate from "../../../img/surveyTemplate 1.png";
import view from "../../../img/viewSurveyVector.svg";
import SurveyService from "../../../services/admin/survey.service";
import userService from "../../../services/user.service";
import Loading from "../../../components/common/Loading";

export const ViewSurvey = () => {
  // const user = getLocalUserProfile();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [allSurveys, setAllSurveys] = useState([]);
  const [filteredSurveys, setFilteredSurveys] = useState([]);
  const [surveyCreator, setSurveyCreator] = useState("");

  useEffect(() => {
    async function getSurveyCreators() {
      try {
        const res = await SurveyService.getAllSurveys();
        setAllSurveys(res.data);

        setFilteredSurveys(res.data);
        const surveysRes: any = res.data;
        for (const survey of surveysRes) {
          const userRes = await userService.getUserProfile(survey.user_id);

          setSurveyCreator(userRes.data.name);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    }
    getSurveyCreators();
  }, []);

  const handleClick = (survey_uuid: string) => {
    navigate(`/admin/survey/single-survey/${survey_uuid}`);
  };

  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    const searchTerm = event.target.value.toLowerCase();

    if (!searchTerm) {
      setFilteredSurveys(allSurveys);
    } else if (searchTerm) {
      if (allSurveys) {
        const filtered = allSurveys.filter((each: any) =>
          each.title.toLowerCase().includes(searchTerm)
        );
        setFilteredSurveys(filtered);
      }
    }
  };

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <Flex
          minHeight={"100vh"}
          height={"auto"}
          boxSizing="border-box"
          maxWidth={"100hw"}
        >
          <Box
            width={["3.5rem", "3.5rem", "3.5rem", "20%"]}
            position="relative"
            top="0"
            left="0"
            zIndex="100"
          >
            <AdminSidebar />
          </Box>
          <Box width="100%">
            <AdminDashboardHeader />
            <Box
              pt="30px"
              px={["20px", "30px"]}
              width={"100%"}
              bg="#F9F8F8"
              height={"auto"}
              minHeight={"95vh"}
              maxHeight={"95vh"}
              overflowX={"scroll"}
              className="scroll-hidden"
            >
              <HStack justifyContent="space-between" pb="40px">
                <Text fontSize="27px" lineHeight="36px" fontWeight="800">
                  Survey
                </Text>
                <Button
                  colorScheme="red"
                  borderRadius="2px"
                  fontSize="13px"
                  fontWeight="600"
                  p="7px"
                  onClick={() => navigate(Adminroutes.Survey)}
                  // disabled={templateStatus}
                >
                  Create Survey
                </Button>
              </HStack>
              <InputGroup
                color="brand.subtitle"
                bg="white"
                borderRadius="12px"
                width={["90%", "90%", "50%", "30%"]}
                //   placeholder="Search"
              >
                <Input
                  height="40px"
                  placeholder="Search"
                  fontSize={14}
                  size="sm"
                  onChange={(e) => handleSearchChange(e)}
                />
                <InputRightElement
                  cursor="pointer"
                  pointerEvents="none"
                  children={<RiSearch2Line color="red" size="1.2rem" />}
                />
              </InputGroup>
              <Center width="90%" mt="2.4rem">
                <Grid
                  templateColumns={[
                    "repeat(1, 1fr)",
                    "repeat(1, 1fr)",
                    "repeat(2, 1fr)",
                    "repeat(4, 1fr)",
                  ]}
                  gap={6}
                  cursor="pointer"
                >
                  {filteredSurveys.length > 0 ? (
                    filteredSurveys?.map((each: any, index: number) => (
                      <GridItem
                        key={index}
                        width="13rem"
                        height="16rem"
                        borderRadius="10px"
                        borderColor="#9E9E9E"
                        borderWidth="0.8px"
                        boxSizing="content-box"
                        onClick={() => handleClick(each.uuid)}
                      >
                        <Center
                          height="80%"
                          width="100%"
                          backgroundColor="white"
                          borderTopLeftRadius="10px"
                          borderTopRightRadius="10px"
                        >
                          <Image
                            src={surveytemplate}
                            alt=""
                            objectFit="cover"
                          />
                        </Center>
                        <HStack
                          height="20%"
                          width="100%"
                          borderTop="1px"
                          borderBottomLeftRadius="10px"
                          borderBottomRightRadius="10px"
                          borderColor="#9E9E9E"
                          backgroundColor="white"
                          paddingX="1rem"
                          paddingY="1.4rem"
                        >
                          <img src={view} alt="" />
                          <Box>
                            <Text fontSize="14px" fontWeight="600">
                              {each.title}
                            </Text>
                            {surveyCreator ? (
                              <Text color="#959595" fontSize="12px">
                                Created by {surveyCreator}
                              </Text>
                            ) : (
                              ""
                            )}
                          </Box>
                        </HStack>
                      </GridItem>
                    ))
                  ) : (
                    <Center
                      width="100%"
                      position="relative"
                      fontSize="16px"
                      lineHeight="1.6rem"
                    >
                      <Text>No Survey available, please create Survey</Text>
                    </Center>
                  )}
                </Grid>
              </Center>
            </Box>
          </Box>
        </Flex>
      )}
    </>
  );
};

export default ViewSurvey;
